import { useContext, useEffect, useRef, useState } from "react";

import config from "@/config";
import ArtworkDataContext from "@/context/ArtworkDataContext";
import useStateHandler from "@/hooks/useStateHandler";
import { auth } from "@/services/firebase.service";

import PopupCropTemplateImage from "./components/PopupCropTemplateImage";
import PopupDownloadSuccessful from "./components/PopupDownloadSuccessful";
import PopupDownloadTemplate from "./components/PopupDownloadTemplate";
import PopupSelectTemplate from "./components/PopupSelectTemplate";
import TemplatePreview from "./components/TemplatePreview";

import "./index.css";

const DowloadTemplate = ({ open, close }) => {
  const { state } = useStateHandler();
  const [selectTemplate, setSelectedTemplate] = useState(null);
  const [scaleArtworkPopup, setScaleArtworkPopup] = useState(false);
  const [downloadArtworkPopup, setDownloadArtworkPopup] = useState(false);
  const [downloadArtworkPopupMessage, setDownloadArtworkPopupMessage] =
    useState(null);
  const [croppedUrl, setCroppedUrl] = useState(null);
  const [croppedFIle, setCroppedFile] = useState(null);
  const [templateColor, setTemplateColor] = useState(
    state.user_session?.user_preferences.theme
  );
  const [loadingDownload, setLoadingDownload] = useState(false);

  const templatePreviewRef = useRef(null);

  const { stateHandler } = useStateHandler();

  const measures = {
    story: {
      width: 1080,
      height: 1206,
    },
    post: {
      width: 1080,
      height: 722,
    },
  };

  const { artworkData } = useContext(ArtworkDataContext);
  const image = `https://imagedelivery.net/hAeIC__6Aj746x0RFU1joA/${artworkData.artwork_media.artwork_main_picture.image_id}/public`;

  const exitCrop = () => {
    setScaleArtworkPopup(false);
    close();
  };

  const continueCrop = () => {
    setDownloadArtworkPopup(true);
    setScaleArtworkPopup(false);
    close();
  };

  const downloadTemplateAsPNG = async () => {
    const formData = new FormData();
    formData.append("typeTemplate",selectTemplate);
    formData.append("artwork",artworkData._id);
    formData.append("image",croppedFIle);
    formData.append("colorTemplate",templateColor);

    try {
      setLoadingDownload(true);

      const response = await fetch(`${config.apis.api.url}/artwork-template`, {
        headers: {
          Authorization: `${await auth.currentUser.getIdToken()}`,
        },
        method: "POST",
        body: formData,
      });

      if (!response?.ok) {
        stateHandler.set("temporalPopup", { text: `An error has ocurred, if the problem persists please contact us. ` , style: "bg-red-500" });
        setDownloadArtworkPopup(false);
        setLoadingDownload(false);
        return;
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      setLoadingDownload(false);
      setDownloadArtworkPopupMessage(true);

      const a = document.createElement("a");
      a.href = url;
      a.download = "template.png"; // Set the file name
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      // Trigger the temporal popup on successful download
      stateHandler.set("temporalPopup",{
        text: "Template downloaded successfully", 
        type: "navbar-present"
      });
    } catch (error) {
      console.log(error);
    }
  };

  // This effect is to close the download popup when the download is finished.
  useEffect(() => {
    if (downloadArtworkPopupMessage) {
      setDownloadArtworkPopup(false);
    }
  }, [downloadArtworkPopupMessage]);

  return (
    <>
      <PopupSelectTemplate
        open={open}
        close={close}
        selectTemplate={selectTemplate}
        setSelectedTemplate={setSelectedTemplate}
        onClick={() => {
          setScaleArtworkPopup(true);
        }}
      />

      <PopupCropTemplateImage
        open={scaleArtworkPopup}
        image={image}
        selectTemplate={selectTemplate}
        measures={measures}
        exitCrop={exitCrop}
        setCroppedUrl={setCroppedUrl}
        setCroppedFile={setCroppedFile}
        continueCrop={continueCrop}
      />

      <PopupDownloadTemplate
        open={downloadArtworkPopup}
        setTemplateColor={setTemplateColor}
        selectTemplate={selectTemplate}
        templateColor={templateColor}
        isLoadingDownload={loadingDownload}
        onClose={() => {
          setDownloadArtworkPopup(false);
          close();
        }}
        onClick={() => {
          downloadTemplateAsPNG(selectTemplate);
        }}
      >
        <div className="felx col">
          <TemplatePreview
            reference={templatePreviewRef}
            croppedUrl={croppedUrl}
            templateColor={templateColor}
            templateType={selectTemplate}
          />
        </div>
      </PopupDownloadTemplate>

      <PopupDownloadSuccessful
        open={downloadArtworkPopupMessage}
        close={() => {
          /* Este pop up lo cierro aquí porque si no interfiere con la descarga del template */
          setDownloadArtworkPopup(false);
          setDownloadArtworkPopupMessage(false);
        }}
        selectTemplate={selectTemplate}
      >
        <TemplatePreview
          reference={templatePreviewRef}
          croppedUrl={croppedUrl}
          templateColor={templateColor}
          templateType={selectTemplate}
        />
      </PopupDownloadSuccessful>
    </>
  );
};

export default DowloadTemplate;
